import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana70Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <rect width="1221" height="921" fill="url(#pattern0_1465_19737)"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    d="M252.231 552.49H278.391V614.983H226.071L252.231 552.49Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}
    d="M320.536 551.035L278.39 552.488V614.982H320.536V551.035Z" 
    fill={getFillByLot(2, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}
    d="M362.689 551.035H320.542V613.528H362.689V551.035Z" 
    fill={getFillByLot(3, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("18"))}
    d="M208.632 655.676L226.072 614.982H262.405V668.756L214.446 670.209C205.144 669.046 206.694 660.52 208.632 655.676Z" 
    fill={getFillByLot(18, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("17"))}
    d="M310.368 668.756H262.408V614.982H310.368V668.756Z" 
    fill={getFillByLot(17, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("16"))}
    d="M356.874 668.756H310.368V614.982H356.874V668.756Z" 
    fill={getFillByLot(16, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("4"))}
    d="M404.834 549.586L362.688 551.039V613.532L404.834 612.079V549.586Z" 
    fill={getFillByLot(4, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("5"))}
    d="M446.981 548.131L404.834 549.584V612.077L446.981 610.624V548.131Z" 
    fill={getFillByLot(5, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("6"))}
    d="M489.127 546.678L446.98 548.131V609.171L489.127 607.718V546.678Z" 
    fill={getFillByLot(6, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("7"))}
    d="M529.819 545.225L489.126 546.678V607.718L529.819 606.264V545.225Z" 
    fill={getFillByLot(7, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("8"))}
    d="M571.966 545.225H529.82V605.605H571.966V545.225Z" 
    fill={getFillByLot(8, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("9"))}
    d="M599.58 545.225H571.967V604.811H627.194L599.58 545.225Z" 
    fill={getFillByLot(9, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("10"))}
    d="M647.537 645.504L627.19 604.811H592.311V664.397H637.364C647.828 663.234 648.506 650.348 647.537 645.504Z" 
    fill={getFillByLot(10, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("11"))}
    d="M545.809 664.397H592.316V604.811L545.809 606.264V664.397Z" 
    fill={getFillByLot(11, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("12"))}
    d="M497.844 664.393H545.804V606.26L497.844 607.713V664.393Z" 
    fill={getFillByLot(12, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("13"))}
    d="M451.336 664.397H497.843V607.717L451.336 610.623V664.397Z" 
    fill={getFillByLot(13, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("14"))}
    d="M403.378 665.848L451.338 664.394V610.621L403.378 612.074V665.848Z" 
    fill={getFillByLot(14, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("15"))}
    d="M356.869 668.76L403.376 665.853V612.08L356.869 613.533V668.76Z" 
    fill={getFillByLot(15, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <defs>
    <pattern id="pattern0_1465_19737" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1465_19737" transform="matrix(0.00199348 0 0 0.00264283 -3.44757 -1.82293)"/>
    </pattern>
    <image id="image0_1465_19737" width="4096" height="2304" href="/mz2.png"/>
  </defs>
</svg>

  );
};
